import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import useGetCommonEntityByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetCommonEntityByID'
import CustomFormCommonEntityCard from 'components/tools/CustomForm/commonComponents/CustomFormCommonEntityCard'
import SearchEntityOnCustomForm from './views/SearchEntityOnCustomForm'
import SelectEntityOnCustomForm from './views/SelectEntityOnCustomForm'
import { useCustomFormCommonEntityPropsManager } from './contexts/CustomFormCommonEntityPropsManager/Provider'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormCommonEntitySelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getEntity, loadingEntity } = useGetCommonEntityByID()

  const { currentEntity, setSelectedEntity, selectedEntity, view, filter } = useCustomFormCommonEntityPropsManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_ENTITY: <SearchEntityOnCustomForm onClose={onClose} />,
      SELECT_ENTITY: <SelectEntityOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadEntity(entityId: string) {
    const entityFromAPI = await getEntity({ entityId, entityKey: currentEntity.key })
    setSelectedEntity(entityFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const entityId = question.default_value[0]
        await loadEntity(entityId)
      }
      if (question.answer && question.answer.length > 0) {
        const entityId = question.answer[0]
        await loadEntity(entityId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingEntity}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedEntity?.id ? `Atualizar ${currentEntity.label}` : `Adicionar ${currentEntity.label}`}
      </Button>

      {selectedEntity?.id && (
        <CustomFormCommonEntityCard entity={selectedEntity} borderWidth="1px" borderColor="borderColor" />
      )}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormCommonEntitySelectionDrawerContent
